import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=10db5468&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10db5468')) {
      api.createRecord('10db5468', component.options)
    } else {
      api.reload('10db5468', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=10db5468&", function () {
      api.rerender('10db5468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l4tHitJsCT70/JS/comp/starrating.vue"
export default component.exports